import { FC } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { fetchWhatsAppAccountsQuery } from 'api/queries/whatsAppAccounts';
import { FetchWhatsAppAccountsResponse } from '../types';
import { WhatsAppAccountsQueryContext } from './WhatsAppAccountsContext';

export const WhatsAppAccountsQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { data: whatsAppAccounts = {}, isLoading: isLoadingWhatsAppAccounts } =
    useGraphql<FetchWhatsAppAccountsResponse>(fetchWhatsAppAccountsQuery);

  return (
    <WhatsAppAccountsQueryContext.Provider
      value={{
        whatsAppAccounts,
        isLoadingWhatsAppAccounts,
      }}
    >
      {children}
    </WhatsAppAccountsQueryContext.Provider>
  );
};
